import * as React from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

type LatLng = { lat: number; lng: number };

interface MapPickerProps {
  defaultCenter: LatLng;
  defaultZoom?: number;
  onChange: (pos: LatLng) => void;
}

export function MapPicker({
  defaultCenter,
  defaultZoom = 12,
  onChange,
}: MapPickerProps) {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const mapRef = React.useRef<L.Map>();
  const markerRef = React.useRef<L.Marker>();

  React.useEffect(() => {
    if (!containerRef.current) return;

    // 1) Create the map once
    const map = L.map(containerRef.current, {
      center: [defaultCenter.lat, defaultCenter.lng],
      zoom: defaultZoom,
    });
    mapRef.current = map;

    // 2) Tile layer
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "",
    }).addTo(map);

    // 3) Click handler
    map.on("click", (e) => {
      const pos = { lat: e.latlng.lat, lng: e.latlng.lng };
      onChange(pos);

      if (markerRef.current) {
        // move existing marker
        markerRef.current.setLatLng(e.latlng);
      } else {
        // first click: create the marker
        markerRef.current = L.marker(e.latlng).addTo(map);
      }
    });

    // cleanup
    return () => {
      map.off();
      map.remove();
    };
  }, [defaultCenter, defaultZoom, onChange]);

  return (
    <div
      ref={containerRef}
      style={{ height: 200, width: "100%" }}
    />
  );
}